const resultColor = {
    'color_0_50_all': 'grey',
    'color_all_x': 'dark red',
    'color_50_75_0_25': 'red 1',
    'color_50_75_25_50': 'orange 1',
    'color_50_75_50_75': 'yellow 1',
    'color_50_75_75_90': 'lgreen 1',
    'color_50_75_90_100': 'green 1',
    'color_75_90_0_25': 'red 2',
    'color_75_90_25_50': 'orange 2',
    'color_75_90_50_75': 'yellow 2',
    'color_75_90_75_90': 'lgreen 2',
    'color_75_90_90_100': 'green 2',
    'color_90_100_0_25': 'red 3',
    'color_90_100_25_50': 'orange 3',
    'color_90_100_50_75': 'yellow 3',
    'color_90_100_75_90': 'lgreen 3',
    'color_90_100_90_100': 'green 3',
};

const resultSmile = {
    'smile_0_50_all': 'question',
    'smile_all_x': 'sad',
    'smile_50_75_0_25': 'angry',
    'smile_50_75_25_50': 'wave',
    'smile_50_75_50_75': 'wave',
    'smile_50_75_75_90': 'line',
    'smile_50_75_90_100': 'smile',
    'smile_75_90_0_25': 'cry',
    'smile_75_90_25_50': 'angry',
    'smile_75_90_50_75': 'line',
    'smile_75_90_75_90': 'smile',
    'smile_75_90_90_100': 'happy',
    'smile_90_100_0_25': 'cry',
    'smile_90_100_25_50': 'angry',
    'smile_90_100_50_75': 'line',
    'smile_90_100_75_90': 'happy',
    'smile_90_100_90_100': 'laugh',
};

const resultTitle = {
    'title_0_50_all': 'A approfondir',
    'title_all_x': 'A proscrire',
    'title_50_75_0_25': 'Ce n’est probablement pas pour vous',
    'title_50_75_25_50': 'Mal parti',
    'title_50_75_50_75': 'C’est flou',
    'title_50_75_75_90': 'à approfondir',
    'title_50_75_90_100': 'C’est bien parti !',
    'title_75_90_0_25': 'Ce n’est certainement pas pour vous',
    'title_75_90_25_50': 'De gros doutes',
    'title_75_90_50_75': 'Incertain',
    'title_75_90_75_90': 'A envisager',
    'title_75_90_90_100': 'Très intéressant !',
    'title_90_100_0_25': 'Ce n’est pas pour vous',
    'title_90_100_25_50': 'Pas vraiment ça',
    'title_90_100_50_75': 'à maturer',
    'title_90_100_75_90': 'Intéressant',
    'title_90_100_90_100': 'Allez-y, foncez !',
};

const resultText = {
    'text_0_50_all': 'Cet emploi est insuffisamment renseigné au regard de vos critères pour vous permettre de vous déterminer.',
    'text_all_x': 'Cet emploi ne correspond pas à vos souhaits, notamment parce qu’il inclut un/des critère(s) inacceptable(s): XXX',
    'text_50_75_0_25': 'Cet emploi dispose de peu d’attendus qui vous correspondent',
    'text_50_75_25_50': 'Cet emploi ne pas semble disposer des atouts que vous recherchez..',
    'text_50_75_50_75': 'Cet emploi semble avoir des éléments positifs, notamment XXX',
    'text_50_75_75_90': 'Cet emploi semble plutôt correspondre à vos souhaits., notamment XXX',
    'text_50_75_90_100': 'Cet emploi semble correspondre pleinement à vos souhaits, notamment en ce qui concerne XXX',
    'text_75_90_0_25': 'Cet emploi ne semble pas disposer des attendus qui vous correspondent',
    'text_75_90_25_50': 'Cet emploi semble disposer de quelques atouts mais en quantité insuffisante.',
    'text_75_90_50_75': 'Cet emploi semble avoir des éléments positifs, notamment XXX',
    'text_75_90_75_90': 'Cet emploi semble plutôt correspondre à vos souhaits., notamment XXX',
    'text_75_90_90_100': 'Cet emploi semble correspondre pleinement à vos souhaits, notamment en ce qui concerne XXX',
    'text_90_100_0_25': 'Cet emploi ne dispose pas des attendus qui vous correspondent',
    'text_90_100_25_50': 'Cet emploi dispose de quelques atouts mais en quantité insuffisante : XXX',
    'text_90_100_50_75': 'Cet emploi a des éléments positifs, notamment XXX. Vous devriez y réfléchir  plus avant.',
    'text_90_100_75_90': 'Cet emploi semble correspondre à vos souhaits, notamment en ce qui concerne XXX Vous devriez l’envisager sérieusement.',
    'text_90_100_90_100': 'Cet emploi correspond parfaitement à vos souhaits, notamment en ce qui concerne XXX Aucune hésitation, postulez !',
};

const resultTextBelow = {
    'text_0_50_all': 'Vous n’avez en effet fourni aucune information sur les critères suivants: XXX Cherchez les éléments à ce sujet afin d’évaluer au mieux la pertinence de cet emploi.',
    'text_all_x': '',
    'text_50_75_0_25': 'Cette vision peut-être approfondie par l’étude complémentaire des critères encore non renseignés : XXX',
    'text_50_75_25_50': 'Il est cependant insuffisamment renseigné pour être sûr qu’il ne correspond pas à vos souhaits. Pour vous en assurer, renseignez les critères encore inconnus : XXX',
    'text_50_75_50_75': 'Trop d’éléments inconnus méritent cependant d’être éclaircis pour que puissiez vous déterminer. Poursuivez vos investigations sur les critères XXX avant de décider',
    'text_50_75_75_90': 'Trop d’éléments inconnus méritent cependant d’être éclaircis pour que puissiez vous déterminer en toute connaissance de cause. Poursuivez vos investigations sur les critères XXX avant de décider',
    'text_50_75_90_100': 'Trop d’éléments inconnus méritent cependant d’être éclaircis pour que puissiez vous déterminer en toute connaissance de cause. Poursuivez vos investigations sur les critères XXX avant de décider',
    'text_75_90_0_25': 'Vous devriez porter votre attention sur d’autres emplois correspondant plus à vos attentes, d’autant que quelques critères sont encore dans le flou: XXX',
    'text_75_90_25_50': 'Vous devriez chercher d’autres emplois mais pouvez approfondir les critères non renseignés pour vous en assurer: XXX',
    'text_75_90_50_75': 'Les éléments inconnus méritent cependant d’être éclaircis pour que vous y réfléchissiez plus avant. Poursuivez vos investigations sur les critères XXX',
    'text_75_90_75_90': 'Vous devriez porter attention aux éléments qui vous sont encore inconnus XXX pour l’envisager sérieusement',
    'text_75_90_90_100': 'Essayez de lever les éléments encore inconnus XXX pour vérifier qu’il n’y a aucun inacceptable et postuler sans hésitation',
    'text_90_100_0_25': 'Vous devriez porter votre attention sur d’autres emplois correspondant plus à vos attentes',
    'text_90_100_25_50': 'vous gagneriez à porter votre attention sur d’autres emplois.',
    'text_90_100_50_75': '',
    'text_90_100_75_90': '',
    'text_90_100_90_100': '',
};

export class OffersResult {
    colors = resultColor;
    smilies= resultSmile;
    resultTitle= resultTitle;
    resultText= resultText;
    resultText_below= resultTextBelow;
    result_all: any;

    constroctor(search: string) {
    }

    getResult(searchValue) {
        if (searchValue === '0_50_all') {
            this.result_all = {
                color: this.colors['color_0_50_all'],
                title: this.resultTitle['title_0_50_all'],
                smile: this.smilies['smile_0_50_all'],
                text: this.resultText['text_0_50_all'],
                text_below: this.resultText_below['text_0_50_all']
            };
        } else if (searchValue === 'all_x') {
            this.result_all = {
                color: this.colors['color_all_x'],
                title: this.resultTitle['title_all_x'],
                smile: this.smilies['smile_all_x'],
                text: this.resultText['text_all_x'],
                text_below: this.resultText_below['text_all_x']
            };
        } else if (searchValue === '50_75_0_25') {
            this.result_all = {
                color: this.colors['color_50_75_0_25'],
                title: this.resultTitle['title_50_75_0_25'],
                smile: this.smilies['smile_50_75_0_25'],
                text: this.resultText['text_50_75_0_25'],
                text_below: this.resultText_below['text_50_75_0_25']
            };
        } else if (searchValue === '50_75_25_50') {
            this.result_all = {
                color: this.colors['color_50_75_25_50'],
                title: this.resultTitle['title_50_75_25_50'],
                smile: this.smilies['smile_50_75_25_50'],
                text: this.resultText['text_50_75_25_50'],
                text_below: this.resultText_below['text_50_75_25_50']
            };
        } else if (searchValue === '50_75_50_75') {
            this.result_all = {
                color: this.colors['color_50_75_50_75'],
                title: this.resultTitle['title_50_75_50_75'],
                smile: this.smilies['smile_50_75_50_75'],
                text: this.resultText['text_50_75_50_75'],
                text_below: this.resultText_below['text_50_75_50_75']
            };
        } else if (searchValue === '50_75_75_90') {
            this.result_all = {
                color: this.colors['color_50_75_75_90'],
                title: this.resultTitle['title_50_75_75_90'],
                smile: this.smilies['smile_50_75_75_90'],
                text: this.resultText['text_50_75_75_90'],
                text_below: this.resultText_below['text_50_75_75_90']
            };
        } else if (searchValue === '50_75_90_100') {
            this.result_all = {
                color: this.colors['color_50_75_90_100'],
                title: this.resultTitle['title_50_75_90_100'],
                smile: this.smilies['smile_50_75_90_100'],
                text: this.resultText['text_50_75_90_100'],
                text_below: this.resultText_below['text_50_75_90_100']
            };
        } else if (searchValue === '75_90_0_25') {
            this.result_all = {
                color: this.colors['color_75_90_0_25'],
                title: this.resultTitle['title_75_90_0_25'],
                smile: this.smilies['smile_75_90_0_25'],
                text: this.resultText['text_75_90_0_25'],
                text_below: this.resultText_below['text_75_90_0_25']
            };
        } else if (searchValue === '75_90_25_50') {
            this.result_all = {
                color: this.colors['color_75_90_25_50'],
                title: this.resultTitle['title_75_90_25_50'],
                smile: this.smilies['smile_75_90_25_50'],
                text: this.resultText['text_75_90_25_50'],
                text_below: this.resultText_below['text_75_90_25_50']
            };
        } else if (searchValue === '75_90_50_75') {
            this.result_all = {
                color: this.colors['color_75_90_50_75'],
                title: this.resultTitle['title_75_90_50_75'],
                smile: this.smilies['smile_75_90_50_75'],
                text: this.resultText['text_75_90_50_75'],
                text_below: this.resultText_below['text_75_90_50_75']
            };
        } else if (searchValue === '75_90_75_90') {
            this.result_all = {
                color: this.colors['color_75_90_75_90'],
                title: this.resultTitle['title_75_90_75_90'],
                smile: this.smilies['smile_75_90_75_90'],
                text: this.resultText['text_75_90_75_90'],
                text_below: this.resultText_below['text_75_90_75_90']
            };
        } else if (searchValue === '75_90_90_100') {
            this.result_all = {
                color: this.colors['color_75_90_90_100'],
                title: this.resultTitle['title_75_90_90_100'],
                smile: this.smilies['smile_75_90_90_100'],
                text: this.resultText['text_75_90_90_100'],
                text_below: this.resultText_below['text_75_90_90_100']
            };
        } else if (searchValue === '90_100_0_25') {
            this.result_all = {
                color: this.colors['color_90_100_0_25'],
                title: this.resultTitle['title_90_100_0_25'],
                smile: this.smilies['smile_90_100_0_25'],
                text: this.resultText['text_90_100_0_25'],
                text_below: this.resultText_below['text_90_100_0_25']
            };
        } else if (searchValue === '90_100_25_50') {
            this.result_all = {
                color: this.colors['color_90_100_25_50'],
                title: this.resultTitle['title_90_100_25_50'],
                smile: this.smilies['smile_90_100_25_50'],
                text: this.resultText['text_90_100_25_50'],
                text_below: this.resultText_below['text_90_100_25_50']
            };
        } else if (searchValue === '90_100_50_75') {
            this.result_all = {
                color: this.colors['color_90_100_50_75'],
                title: this.resultTitle['title_90_100_50_75'],
                smile: this.smilies['smile_90_100_50_75'],
                text: this.resultText['text_90_100_50_75'],
                text_below: this.resultText_below['text_90_100_50_75']
            };
        } else if (searchValue === '90_100_75_90') {
            this.result_all = {
                color: this.colors['color_90_100_75_90'],
                title: this.resultTitle['title_90_100_75_90'],
                smile: this.smilies['smile_90_100_75_90'],
                text: this.resultText['text_90_100_75_90'],
                text_below: this.resultText_below['text_90_100_75_90']
            };
        } else if (searchValue === '90_100_90_100') {
            this.result_all = {
                color: this.colors['color_90_100_90_100'],
                title: this.resultTitle['title_90_100_90_100'],
                smile: this.smilies['smile_90_100_90_100'],
                text: this.resultText['text_90_100_90_100'],
                text_below: this.resultText_below['text_90_100_90_100']
            };
        }
        return this.result_all;
    }


}





// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/models/offer-result-details.ts